import type { CustomerProfile } from '@/components/dashboard/Customer360.vue';

/**
 * Mock Customer 360 profiles. Faza 1: GET /api/customers/:id?include=timeline
 *
 * Klucze = customerName (case-sensitive). Lookup fallback: tworzymy synthetic
 * profile z minimal info gdy nie znamy klienta.
 */

export const CUSTOMER_PROFILES: Record<string, CustomerProfile> = {
  'Tomasz Nowak': {
    name: 'Tomasz Nowak',
    phone: '+48 501 234 567',
    email: 'tomasz.nowak@op.pl',
    address: 'ul. Sienkiewicza 12, 25-001 Kielce',
    tier: 'vip',
    ltvCents: 69_900_000, // suma 2 sprzedazy: 229k Formentor + 470k A4 Avant Black Edition
    openLeads: 1,
    closedSales: 2,
    timeline: [
      {
        id: 'tn-1',
        kind: 'lead',
        title: 'Nowy lead: Audi A6 Avant',
        meta: 'Doradca Siodmy · drugi samochod, budzet 300-330k',
        at: '2 dni temu',
        brand: 'Audi',
        source: 'manual',
      },
      {
        id: 'tn-2',
        kind: 'email',
        title: 'Wyslana oferta konfiguracji',
        meta: 'A6 45 TFSI Quattro · 2026 · Daytona Grey',
        at: '5 dni temu',
        source: 'manual',
      },
      {
        id: 'tn-3',
        kind: 'call',
        title: 'Telefon — potwierdzenie budzetu',
        meta: '14 minut · klient gotowy w 2-3 tyg',
        at: '8 dni temu',
      },
      {
        id: 'tn-4',
        kind: 'sale',
        title: 'Cupra Formentor VZ 333KM',
        meta: 'Doradca Pierwszy · Cupra Kielce',
        at: '8 tyg temu',
        amount: 22_900_000, // cennik 237 200 - rabat -8k
        brand: 'Cupra',
        source: 'dms',
      },
      {
        id: 'tn-5',
        kind: 'test_drive',
        title: 'Jazda probna: Cupra Formentor',
        meta: '45 min · uwagi pozytywne (komfort, akcelaracja)',
        at: '10 tyg temu',
      },
      {
        id: 'tn-6',
        kind: 'document',
        title: 'Skan dowodu rejestracyjnego',
        meta: 'Skoda Octavia (auto wymieniane)',
        at: '11 tyg temu',
        source: 'ocr',
      },
      {
        id: 'tn-7',
        kind: 'sale',
        title: 'Audi A4 Avant 45 TFSI quattro Black Edition',
        meta: 'Doradca Siodmy · Audi Kielce',
        at: '18 mies temu',
        amount: 47_000_000, // high-spec A4 Avant 45 TFSI Q PY24 z opcjami
        brand: 'Audi',
        source: 'dms',
      },
    ],
  },

  'Magdalena Krol': {
    name: 'Magdalena Krol',
    phone: '+48 605 112 998',
    email: 'm.krol@gmail.com',
    address: 'ul. Krakowska 200, 25-801 Kielce',
    tier: 'regular',
    ltvCents: 13_500_000, // historyczna sprzedaz Leon 1.5 eTSI 135k
    openLeads: 1,
    closedSales: 1,
    timeline: [
      {
        id: 'mk-1',
        kind: 'lead',
        title: 'Negocjacja: Cupra Formentor VZ',
        meta: 'Doradca Drugi · budzet 180-200k · w czerwonym Magma',
        at: 'dzis',
        brand: 'Cupra',
        source: 'mycarapp',
      },
      {
        id: 'mk-2',
        kind: 'test_drive',
        title: 'Jazda probna: Cupra Formentor VZ',
        meta: '30 min',
        at: '3 dni temu',
      },
      {
        id: 'mk-3',
        kind: 'meeting',
        title: 'Spotkanie w salonie',
        meta: 'Doradca Drugi · prezentacja konfiguracji',
        at: '5 dni temu',
      },
      {
        id: 'mk-4',
        kind: 'document',
        title: 'Lead intake form',
        meta: 'Skanowanie OCR — auto-fill kontaktu',
        at: '1 tydz temu',
        source: 'ocr',
      },
      {
        id: 'mk-5',
        kind: 'sale',
        title: 'Cupra Leon 1.5 eTSI 150KM',
        meta: 'Doradca Drugi · Cupra Kielce',
        at: '14 mies temu',
        amount: 13_500_000, // standard Leon 1.5 eTSI mHEV ~ 130-140k
        brand: 'Cupra',
        source: 'dms',
      },
    ],
  },

  'Beta Consulting': {
    name: 'Beta Consulting Sp. z o.o.',
    phone: '+48 22 567 89 00',
    email: 'fleet@beta-consulting.pl',
    address: 'ul. Marszalkowska 100, 00-001 Warszawa (HQ)',
    tier: 'vip',
    ltvCents: 68_600_000, // 2x Leon FR (25.6k) + 2x Kodiaq L&K (43.0k) = 686 000 zl B2B
    openLeads: 1,
    closedSales: 4,
    timeline: [
      {
        id: 'bc-1',
        kind: 'lead',
        title: 'Flota Seat Tarraco x3',
        meta: 'Doradca Piaty · leasing operacyjny 36mc · decyzja koniec kwartalu',
        at: '3 dni temu',
        brand: 'Seat',
        source: 'erp',
      },
      {
        id: 'bc-2',
        kind: 'email',
        title: 'Oferta leasingu — porownanie',
        meta: 'Tarraco vs Kodiaq, 36mc vs 48mc',
        at: '4 dni temu',
      },
      {
        id: 'bc-3',
        kind: 'meeting',
        title: 'Spotkanie B2B z fleet managerem',
        meta: '2h · analiza kosztu eksploatacji',
        at: '1 tydz temu',
      },
      {
        id: 'bc-4',
        kind: 'sale',
        title: 'Seat Leon FR 1.5 eTSI x2',
        meta: 'Doradca Piaty · Seat Radom · flota B2B z rabatem',
        at: '6 mies temu',
        amount: 25_600_000, // 2x 128 000 brutto - rabat B2B
        brand: 'Seat',
        source: 'dms',
      },
      {
        id: 'bc-5',
        kind: 'sale',
        title: 'Skoda Kodiaq 2.0 TDI Sportline x2',
        meta: 'Doradca Dziesiaty · Skoda Kielce · flota B2B',
        at: '14 mies temu',
        amount: 43_000_000, // 2x ~215k brutto Sportline
        brand: 'Skoda',
        source: 'dms',
      },
    ],
  },
};

/**
 * Lookup customer profile by name. Zwraca synthetic minimal profile gdy brak danych.
 */
export function findCustomer(name: string): CustomerProfile {
  const exact = CUSTOMER_PROFILES[name];
  if (exact) return exact;
  // Synthetic minimal profile — niewazne dla demo, byle bylo cos
  return {
    name,
    tier: 'new',
    openLeads: 1,
    closedSales: 0,
    timeline: [
      {
        id: 'syn-1',
        kind: 'lead',
        title: 'Nowy lead (pelne dane wkrótce)',
        meta: 'Faza 1: pelna historia z DMS + CRM',
        at: 'dzis',
      },
    ],
  };
}
